module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Alert":"Alert","Vote":"Vote"},"pt":{"Alert":"Alerta","Vote":"Votar"}}')
  delete Component.options._Ctor
}
